import { Box, Card, Grid, Typography } from '@mui/material';
import './portal-card-link.scss';
import { Link } from 'react-router';
interface PortalCardLinkProps {
  title: string;
  text: string;
  Icon: React.ElementType;
  path?: string;
}
export const PortalCardLink = (props: PortalCardLinkProps) => {
  const { title, text, Icon } = props;
  return (
    <Card className="portal-card-link">
      <Link to={props.path || ''}>
        <Grid container>
          <Grid className="menu" size={12}>
            <Box className="menu-container">
              <Box className="icon-container">
                <Icon className="icon" />
              </Box>
              <Box className="text-container">
                <Box>
                  <Typography variant="h6">{title}</Typography>
                  <Typography>{text}</Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Link>
    </Card>
  );
};
